import 'angular:locale/data:ar-EG';
import 'angular:locale/data:ru-RU';
import 'angular:locale/data:en-US';
import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
